var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64.3902,
    height: 64.3902,
    rx: 8,
    fill: "url(#paint0_linear_45_132)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 13L18.181 48.3393L32.4544 53L46.819 48.3393L50 13H15ZM43.0911 24.4196H26.3385L26.7122 28.8304H42.7174L41.4779 42.0804L32.5547 44.4911V44.5179H32.4544L23.4583 42.0804L22.9115 35.3125H27.2591L27.5781 38.7143L32.4544 40.0089L37.349 38.7143L37.8958 33.1607H22.6836L21.5169 20.1607H43.4922L43.0911 24.4196Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_132",
    x1: -4.02439,
    y1: -6.03659,
    x2: 59.0244,
    y2: 72.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BAEF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHtml);
export default __webpack_public_path__ + "static/media/icon_html.00eab4185c798c6086e3d51acb242732.svg";
export { ForwardRef as ReactComponent };